import { render, staticRenderFns } from "./ProductRestockAlert.vue?vue&type=template&id=6afd5930&scoped=true"
import script from "./ProductRestockAlert.vue?vue&type=script&lang=js"
export * from "./ProductRestockAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afd5930",
  null
  
)

export default component.exports